import {getConfig} from 'config';
import {getData} from '../dataProvider';

export const loadExtensions = () => {
  return getData(`${getConfig('extensionsUrl')}`);
};
